import { render } from "./ProgrammeOwnerDetail.vue?vue&type=template&id=c6c07598"
import script from "./ProgrammeOwnerDetail.vue?vue&type=script&lang=js"
export * from "./ProgrammeOwnerDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__